import { ShieldWarning } from '@/core/ui/icons';
import { Button, Card } from '@/core/ui';
import { useLogout } from '../application/session';

export function AccessBlocked({ title, message }: { title: string; message: string }) {
  const logout = useLogout();
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md p-8 text-center">
        <span className="mx-auto flex size-12 items-center justify-center rounded-full bg-amber-500/10 text-amber-300 light:text-amber-700">
          <ShieldWarning aria-hidden className="size-6" />
        </span>
        <h1 className="mt-4 text-lg font-semibold">{title}</h1>
        <p className="mt-2 text-sm text-fg-subtle">{message}</p>
        <Button variant="secondary" className="mt-6" onClick={logout}>
          Sair
        </Button>
      </Card>
    </div>
  );
}
